import { Component, OnInit} from '@angular/core';
import { Validation } from '../../../config/validation';
import { RegistroService } from '../../../services/registro.service';
import { SweetMessage } from '../../../config/sweet-message';

class Registro{
	constructor(
		public codigo: String = "",
		public cedula_ruc: String = "",
		public razon_social: String = "",
		public correo: String = "",
		//public celular: String = "",
		//public direccion: String = "",
		//public cedula_usuario: String = "",
		//public nombres: String = "",
		//public apellidos: String = "",
		public usuario: String = "",
		public clave: String = "",
		public confirmarClave: String = "",
		public recaptcha: String = "",
	){}
}

@Component({
	selector: 'registro',
	templateUrl: './registro.component.html',
	styleUrls: ['./registro.component.css'],
	providers: [RegistroService]
})
export class RegistroComponent implements OnInit {
	public registro: Registro;
	public vl: Validation;
	public loading = false;
	public msg: SweetMessage;

	constructor(private rs: RegistroService) {
		this.registro = new Registro();
		this.vl = new Validation();
		this.msg = new SweetMessage();
	}

	ngOnInit() {
		//
	}

	onSubmit(){
		this.loading = true;
		this.rs.save(this.registro).subscribe(
			res => {
				this.loading = false;
				this.registro = new Registro();
				this.msg.showMessage('success-message', "Te has registrado con éxito. Te hemos enviado un correo");
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message', err);
			}
		);
	}

	isValidForm(){
		if( !this.registro.codigo.trim().length ){
			return false;
		}
		if( !this.registro.cedula_ruc.trim().length ){
			return false;
		}
		if( !this.registro.razon_social.trim().length ){
			return false;
		}
		if( !this.registro.correo.trim().length ){
			return false;
		}
		/*if( !this.registro.celular.trim().length ){
			return false;
		}*/
		/*if( !this.registro.direccion.trim().length ){
			return false;
		}*/
		/*if( !this.registro.cedula_usuario.trim().length ){
			return false;
		}*/
		/*if( !this.registro.nombres.trim().length ){
			return false;
		}*/
		/*if( !this.registro.apellidos.trim().length ){
			return false;
		}*/
		if( !this.registro.usuario.trim().length ){
			return false;
		}
		if( !this.registro.clave.trim().length ){
			return false;
		}
		if( !this.registro.recaptcha.trim().length ){
			return false;
		}
		return true;
	}

	resolved(captchaResponse: string) {
		this.registro.recaptcha = captchaResponse;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/login/registro/registro.component.ts